if (!customElements.get('mas-delivery-date')) {
  customElements.define('mas-delivery-date', class extends HTMLElement {
    static swissNow(now) {
      const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Zurich', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' }).formatToParts(now);
      const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
      return { date: new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day))), beforeCutoff: Number(values.hour) < 20 };
    }
    static easter(year) {
      const a = year % 19;
      const b = Math.floor(year / 100);
      const c = year % 100;
      const d = Math.floor(b / 4);
      const e = b % 4;
      const f = Math.floor((b + 8) / 25);
      const g = Math.floor((b - f + 1) / 3);
      const h = (19 * a + b - d - g + 15) % 30;
      const i = Math.floor(c / 4);
      const k = c % 4;
      const l = (32 + 2 * e + 2 * i - h - k) % 7;
      const m = Math.floor((a + 11 * h + 22 * l) / 451);
      const month = Math.floor((h + l - 7 * m + 114) / 31);
      return new Date(Date.UTC(year, month - 1, (h + l - 7 * m + 114) % 31 + 1));
    }
    static workingDay(date) {
      if ([0, 6].includes(date.getUTCDay())) return false;
      const key = date.toISOString().slice(5, 10);
      if (['01-01', '01-02', '08-01', '12-25', '12-26'].includes(key)) return false;
      const easter = this.easter(date.getUTCFullYear());
      return ![-2, 1, 39, 50].some(offset => easter.getTime() + offset * 86400000 === date.getTime());
    }
    static nextWorkingDay(date) {
      const next = new Date(date);
      do { next.setUTCDate(next.getUTCDate() + 1); } while (!this.workingDay(next));
      return next;
    }
    static estimate(now) {
      const { date, beforeCutoff } = this.swissNow(now);
      if (!beforeCutoff) date.setUTCDate(date.getUTCDate() + 1);
      const handover = this.nextWorkingDay(date);
      const arrival = this.nextWorkingDay(this.nextWorkingDay(handover));
      return { arrival, beforeCutoff };
    }
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      this.variants = JSON.parse(this.querySelector('[data-delivery-variants]')?.textContent || '[]');
      this.onChange = () => this.update();
      this.productInfo?.addEventListener('change', this.onChange);
      if (typeof subscribe === 'function') {
        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (String(data.sectionId) !== this.productInfo?.dataset.section) return;
          this.dataset.variant = data.variant?.id || '';
          this.update();
        });
        this.unsubscribeQuantity = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.onChange);
      }
      this.timer = setInterval(this.onChange, 30000);
      this.update();
    }
    disconnectedCallback() {
      this.productInfo?.removeEventListener('change', this.onChange);
      this.unsubscribeVariant?.();
      this.unsubscribeQuantity?.();
      clearInterval(this.timer);
    }
    update() {
      const form = document.getElementById(this.dataset.productForm);
      const id = form?.querySelector('[name="id"]')?.value ?? this.dataset.variant;
      const variant = this.variants.find(item => String(item.id) === String(id));
      const quantity = Math.max(1, Number(this.productInfo?.querySelector('[name="quantity"]')?.value || 1));
      this.hidden = !variant?.in_stock || (variant.tracked && quantity > variant.quantity);
      if (this.dataset.cartReady !== undefined) this.hidden = this.dataset.cartReady !== 'true';
      if (this.hidden) return;
      const { arrival, beforeCutoff } = this.constructor.estimate(new Date());
      const locale = this.dataset.locale.startsWith('de') ? 'de-CH' : 'en-GB';
      const formatted = new Intl.DateTimeFormat(locale, { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' }).format(arrival);
      this.querySelector('.mas-delivery-date__text').textContent = (beforeCutoff ? this.dataset.before : this.dataset.after).replace('__DATE__', formatted);
    }
  });
}
